import React, { useState } from 'react';
import { ProductsTab } from './lobby/ProductsTab';
import { AccountProfilesTab } from './lobby/AccountProfilesTab';
import { DocumentsTab } from './lobby/DocumentsTab';
import { ApplicationStatus } from './lobby/ApplicationStatus';
import { NextSteps } from './lobby/NextSteps';
import { HelpCircleIcon, ShoppingCartIcon } from 'lucide-react';
export const Lobby = () => {
  const [activeTab, setActiveTab] = useState('products');
  const applicantData = {
    businessName: 'Vandelay Industries',
    applicants: [{
      name: 'George Costanza',
      role: 'Primary Applicant',
      status: 'Verified',
      ownership: '70%'
    }, {
      name: 'Art Vandelay',
      role: 'Joint Applicant',
      status: 'Pending',
      ownership: '30%'
    }],
    products: [{
      name: 'Premier Checking Account',
      type: 'Checking',
      status: 'Approved'
    }, {
      name: 'Business Savings Account',
      type: 'Savings',
      status: 'Approved'
    }],
    documents: [{
      name: 'Proof of Address.pdf',
      date: '05/15/2023',
      type: 'Proof of Address'
    }],
    applicationStatus: 'In Progress',
    businessStructure: 'Limited Liability Corp (LLC)'
  };
  return <div className="flex flex-col w-full min-h-screen bg-white" data-id="element-236">
      <header className="w-full py-4 px-6 flex justify-between items-center border-b border-gray-200 bg-white" data-id="element-237">
        <div className="flex items-center" data-id="element-238">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7Frqi3Qp7tZbKVGUnkz12Q/Screenshot_2025-08-08_at_5.52.22_PM.png" alt="Veritran Logo" className="h-8 mr-3" data-id="element-239" />
          <div data-id="element-240">
            <h1 className="text-lg font-bold text-gray-800" data-id="element-241">Veritran</h1>
            <p className="text-xs text-gray-600" data-id="element-242">Digital Account Opening</p>
          </div>
        </div>
        <div className="flex items-center" data-id="element-243">
          <div className="mr-4 text-sm text-gray-600" data-id="element-244">RC</div>
          <button className="text-black p-2" aria-label="Shopping cart" data-id="element-245">
            <ShoppingCartIcon size={24} data-id="element-246" />
          </button>
        </div>
      </header>
      <div className="flex flex-1" data-id="element-247">
        <main className="flex-1 p-6 border-r border-gray-200" data-id="element-248">
          <h1 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-249">
            Welcome, {applicantData.businessName}
          </h1>
          <div className="border-b border-gray-200 mb-6" data-id="element-250">
            <nav className="flex -mb-px" data-id="element-251">
              <button className={`mr-8 py-4 px-1 font-medium text-sm ${activeTab === 'products' ? 'border-b-2 border-[#5c5cf5] text-[#5c5cf5]' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('products')} data-id="element-252">
                Products
              </button>
              <button className={`mr-8 py-4 px-1 font-medium text-sm ${activeTab === 'profiles' ? 'border-b-2 border-[#5c5cf5] text-[#5c5cf5]' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('profiles')} data-id="element-253">
                Account Profiles
              </button>
              <button className={`mr-8 py-4 px-1 font-medium text-sm ${activeTab === 'documents' ? 'border-b-2 border-[#5c5cf5] text-[#5c5cf5]' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('documents')} data-id="element-254">
                Documents
              </button>
            </nav>
          </div>
          {activeTab === 'products' && <ProductsTab data={applicantData} data-id="element-255" />}
          {activeTab === 'profiles' && <AccountProfilesTab data={applicantData} data-id="element-256" />}
          {activeTab === 'documents' && <DocumentsTab data={applicantData} data-id="element-257" />}
        </main>
        <aside className="w-80 p-6 bg-white" data-id="element-258">
          <div className="mb-8" data-id="element-259">
            <h2 className="text-lg font-medium text-gray-800 mb-4" data-id="element-260">Details</h2>
            <ApplicationStatus data={applicantData} data-id="element-261" />
          </div>
          <div data-id="element-262">
            <h2 className="text-lg font-medium text-gray-800 mb-4" data-id="element-263">
              Next Steps
            </h2>
            <NextSteps data-id="element-264" />
          </div>
        </aside>
      </div>
      <div className="fixed bottom-6 right-6" data-id="element-265">
        <button className="w-12 h-12 bg-white rounded-full border border-gray-300 flex items-center justify-center shadow-md" data-id="element-266">
          <HelpCircleIcon size={24} className="text-gray-700" data-id="element-267" />
        </button>
      </div>
    </div>;
};